import {Card} from '@mui/material'
import {Texts} from 'appearance'
import {
    Area,
    AreaChart,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts'
import {useI18n} from 'store/Store'
import CustomTooltip from '../Chart/CustomTooltip'

const isEmpty = (data) =>
    data.every((d) => d.done === 0 && d.expired === 0 && d.pending === 0)

const RequestsChart = ({title, data}) => {
    const {i18n} = useI18n()

    if (isEmpty(data)) {
        return (
            <Card
                variant="outlined"
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                dir="ltr">
                <Texts.Title>{i18n.t('dashboard.noRequests')}</Texts.Title>
            </Card>
        )
    }

    const formatLegend = (value) => {
        return i18n.t(`dashboard.${value}`)
    }

    return (
        <Card
            variant="outlined"
            style={{width: '100%', height: '100%'}}
            dir="ltr">
            <ResponsiveContainer>
                <AreaChart
                    data={data}
                    margin={{
                        top: 50,
                        right: 30,
                        left: 0,
                        bottom: 0,
                    }}>
                    <text
                        x={790}
                        y={25}
                        fill="black"
                        textAnchor="middle"
                        dominantBaseline="central">
                        <tspan fontSize="20" fontWeight="bold">
                            {i18n.t(`dashboard.allRequests`)}
                        </tspan>
                    </text>
                    <defs>
                        <linearGradient
                            id="colorPv"
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="1">
                            <stop
                                offset="1%"
                                stopColor="#50A1FF"
                                stopOpacity={0.3}
                            />
                            <stop
                                offset="99%"
                                stopColor="#FFFFFF"
                                stopOpacity={0.5}
                            />
                        </linearGradient>
                    </defs>

                    <defs>
                        <linearGradient
                            id="colorUv"
                            x1="0%"
                            y1="0"
                            x2="100%"
                            y2="0">
                            <stop offset="0%" stop-color="#50A1FF" />
                            <stop offset="25%" stop-color="#FF7C80" />
                            <stop offset="50%" stop-color="#50A1FF" />
                            <stop offset="75%" stop-color="#FF7C80" />
                            <stop offset="100%" stop-color="#50A1FF" />
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />

                    <Area
                        type="monotone"
                        dataKey="pending"
                        stroke="url(#colorUv)"
                        strokeWidth={3}
                        fill="url(#colorPv)"
                        fillOpacity={1}
                        activeDot={{
                            stroke: '#323232',
                            strokeWidth: 1,
                            fill: '#CBDDEE',
                            r: 7,
                            strokeDasharray: '',
                        }}
                    />

                    <Area
                        type="monotone"
                        dataKey="done"
                        stroke="blue"
                        strokeWidth={3}
                        fill="url(#colorPv)"
                        fillOpacity={1}
                        activeDot={{
                            stroke: '#323232',
                            strokeWidth: 1,
                            fill: '#CBDDEE',
                            r: 7,
                            strokeDasharray: '',
                        }}
                    />

                    <Area
                        type="monotone"
                        dataKey="expired"
                        stroke="red"
                        strokeWidth={1}
                        fill="transparent"
                        fillOpacity={1}
                        activeDot={{
                            stroke: '#323232',
                            strokeWidth: 1,
                            fill: '#CBDDEE',
                            r: 7,
                            strokeDasharray: '',
                        }}
                    />
                    <Legend formatter={formatLegend} />
                </AreaChart>
            </ResponsiveContainer>
        </Card>
    )
}

export default RequestsChart
